import { render, staticRenderFns } from "./ServiceModulesForm.vue?vue&type=template&id=58b03372&"
import script from "./ServiceModulesForm.vue?vue&type=script&lang=js&"
export * from "./ServiceModulesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports